export default __webpack_public_path__ + "static/media/Eye_2_M_C3.bdef8e66.svg";